import { tmxApiCall } from './index'

// Utilities
import Logger from '../utility/loggerUtil'

export default {
  /**
   * Gets a videos source url for a given video name
   * @param {String} videoKey - The database identifier for the desired video url
   * @returns {Promise<{videoUrl: String}>} A video url
   */
  async getVideoUrl (videoKey) {
    Logger.info('Started to get video url.')
    return tmxApiCall('get', '/videoUrl', {
      params: {
        videoKey
      }
    })
  }
}
